import { lazy, Suspense } from "react";

// Lazy load SparklesCore to reduce initial bundle size
const SparklesCoreLazy = lazy(() => 
  import("./sparkles").then(module => ({ default: module.SparklesCore }))
);

interface SparklesCoreLazyProps {
  id?: string;
  className?: string;
  background?: string;
  particleSize?: number;
  minSize?: number;
  maxSize?: number;
  speed?: number;
  particleColor?: string;
  particleDensity?: number;
}

export const SparklesCoreLazyWrapper = (props: SparklesCoreLazyProps) => {
  return (
    <Suspense fallback={<div className={props.className || ""} />}>
      <SparklesCoreLazy {...props} />
    </Suspense>
  );
};

